const actionType = {
    GET_ALL_REF_DATA_SOURCE_CONFIGURATION_SUCCESS: 'GET_ALL_REF_DATA_SOURCE_CONFIGURATION_SUCCESS',
    GET_REF_DATA_SOURCE_MAPPING: 'GET_REF_DATA_SOURCE_MAPPING',
    UPDATE_SOURCE_NAMES: 'UPDATE_SOURCE_NAMES',
    GET_REF_SOURCE_SELECTION_BOX: 'GET_REF_SOURCE_SELECTION_BOX',
    GET_ALL_SOURCE_IMPORT_COMMENTS: 'GET_ALL_SOURCE_IMPORT_COMMENTS',
    GET_ALL_SOURCE_SETTINGS: 'GET_ALL_SOURCE_SETTINGS',
};
export default actionType;
